import { get, post, postJson, deleteApi } from './axios'

// 客户分群---人群运算

const RESOURCE_BASE_PATH = '/precision-crowd-calculate-task'

// 获取人群运算列表
export const getPrecisionCrowdList = p => get(`${RESOURCE_BASE_PATH}/list`, p);

// 批量删除人群运算任务
export const delPrecisionCrowdTask = p => postJson(`${RESOURCE_BASE_PATH}/batch`, p);

// 创建人群运算任务
export const postPrecisionCrowdTask = p => postJson(`${RESOURCE_BASE_PATH}`, p);

//批量删除人群
export const  delPrecisionCrowdMember = p => postJson(`/memberCrowd/batch`, p);